(() => {
  const init = (root = document) => {
    const toggles = root.querySelectorAll('[data-pti-toggle]');

    toggles.forEach((toggle) => {
      if (toggle.dataset.ptiBound === 'true') return;
      toggle.dataset.ptiBound = 'true';

      toggle.addEventListener('click', () => {
        const item = toggle.closest('.pti__ingredient-item');
        if (!item) return;

        const shortText = item.querySelector('[data-pti-short]');
        const fullText = item.querySelector('[data-pti-full]');
        if (!shortText || !fullText) return;

        const expanded = toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          shortText.hidden = false;
          fullText.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = 'Read more';
        } else {
          shortText.hidden = true;
          fullText.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          toggle.textContent = 'Read less';
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
